<template>
  <div>
    <CDialog>
      <h3 slot="title" class="heading-lined">
        {{ $t('profitloss.reset_portfolio_text') }}
      </h3>

      <div slot="actions">
        <button class="btn btn-primary btn-block" @click="submit">
          <i class="fa fa-trash pr-2"></i>
          {{ $t('edit_asset_page.delete') }}
        </button>

        <button class="btn btn-secondary btn-block mt-3" @click="close">
          {{ $t('exchange.cancel') }}
        </button>
      </div>
    </CDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import CDialog from "./../Dialog";

export default {
  name: "ShareDialog",
  components: {
    CDialog,
  },
  methods: {
    close() {
      this.toggleDialog("profitlossDeteleAll", false);
    },
    submit() {
      this.removeAllTransactions();
      this.close();
    },
    ...mapActions({
      removeAllTransactions: "profitloss/removeAllTransactions",
      toggleDialog: "ui/toggleDialog",
    }),
  },
};
</script>
